// Utilidades para optimizar animaciones en dispositivos móviles

// Detectar si es un dispositivo móvil
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = ['mobile', 'android', 'iphone', 'ipad', 'windows phone'];
  
  return mobileKeywords.some(keyword => userAgent.includes(keyword)) || 
         window.innerWidth <= 768;
};

// Detectar si el dispositivo tiene preferencia por movimiento reducido
export const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

// Clases CSS condicionales para animaciones
export const getAnimationClasses = {
  // Animaciones básicas (siempre activas)
  basic: {
    spin: 'animate-spin',
    pulse: 'animate-pulse',
    bounce: 'animate-bounce'
  },
  
  // Animaciones pesadas (solo en desktop)
  heavy: {
    blob: isMobileDevice() ? '' : 'animate-blob',
    floating: isMobileDevice() ? '' : 'floating',
    breathing: isMobileDevice() ? '' : 'breathing',
    gradient: isMobileDevice() ? '' : 'gradient-animation'
  },
  
  // Animaciones de entrada (optimizadas para móvil)
  entrance: {
    fadeIn: isMobileDevice() ? 'opacity-100' : 'animate-fade-in',
    slideUp: isMobileDevice() ? 'opacity-100 translate-y-0' : 'animate-slide-up',
    appear: isMobileDevice() ? 'opacity-100 scale-100' : 'appear'
  }
};

// Función para aplicar animaciones condicionales
export const applyConditionalAnimation = (
  baseClass: string,
  animationClass: string,
  fallbackClass?: string
): string => {
  if (isMobileDevice() || prefersReducedMotion()) {
    return fallbackClass || baseClass;
  }
  return `${baseClass} ${animationClass}`;
};

// Configuración de animaciones optimizada
export const animationConfig = {
  // Deshabilitar animaciones pesadas en móvil
  disableHeavyAnimations: isMobileDevice(),
  
  // Reducir duración de animaciones en móvil
  duration: isMobileDevice() ? '150ms' : '300ms',
  
  // Simplificar transiciones en móvil
  transition: isMobileDevice() ? 'all 150ms ease-out' : 'all 300ms ease-in-out'
}; 